import { Typography, TypographyProps } from "@mui/material";
import { PropsWithChildren } from "react";

export default function Bold({children, ...props}: PropsWithChildren<TypographyProps>) {
  return (
    <Typography fontWeight={600} alignContent="center" {...props}>
      {children}
    </Typography>
  )
}
